var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","background-color":"#59348B"}},[_c('v-img',{attrs:{"src":"/imgs/Artboard 1 copy@2x.png","height":_vm.$vuetify.breakpoint.xs ? 300 : 500,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }